document.addEventListener('DOMContentLoaded', function() {
  const button = document.querySelector('.slide__buttons .slide__btn');

  if (button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.getElementById('Text--template--24137087123797__section_text_BixYdy');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  const buttons = document.querySelectorAll('.column__item__button');

  buttons.forEach(function(button) {
    const href = button.getAttribute('href');

    if (href === '#agotado') {
      // Desactivar el click
      button.addEventListener('click', function(e) {
        e.preventDefault(); // Evita que el enlace funcione
      });
    }
    
  });



  
});



